module.exports = __webpack_public_path__ + "static/media/find-doctor.faf704c8.svg";